import { createRouter, createWebHashHistory } from 'vue-router'
import AdminHomeView from '../views/AdminHomeView.vue'
import CityExamSignupPublicView from '../views/CityExamSignupPublicView.vue'
import DashboardView from '../views/DashboardView.vue'
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/RegisterView.vue'
import StudentHomeView from '../views/StudentHomeView.vue'
import StudentMoreInfoView from '../views/StudentMoreInfoView.vue'
import TeacherExamRecordManageView from '../views/TeacherExamRecordManageView.vue'
import TeacherGradingWorkspaceView from '../views/TeacherGradingWorkspaceView.vue'
import TeacherPaperManageView from '../views/TeacherPaperManageView.vue'
import TeacherProctorView from '../views/TeacherProctorView.vue'
import TeacherProctorWallView from '../views/TeacherProctorWallView.vue'
import TeacherQuestionManageView from '../views/TeacherQuestionManageView.vue'
import TeacherStudentUserManageView from '../views/TeacherStudentUserManageView.vue'
import EventPublicIntroView from '../views/EventPublicIntroView.vue'
import EventDetailPublicView from '../views/EventDetailPublicView.vue'
import TicketLoginPublicView from '../views/TicketLoginPublicView.vue'
import AutomanSsoView from '../views/AutomanSsoView.vue'

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView,
    meta: { requiresAuth: true }
  },
  {
    path: '/home',
    redirect: '/home/city-signup',
    meta: { requiresAuth: true }
  },
  /**
   * 管理员首页（AdminHomeView）：地市考试报名与「赛事管理」等共用此 path，
   * 通过 query.adminTab 区分：citySignup（默认）| eventManage | cityPaperManage | ticketLoginPageManage。
   * 程序化跳转示例：router.push({ path: '/home/city-signup', query: { adminTab: 'eventManage' } })
   */
  {
    path: '/home/city-signup',
    name: 'home-city-signup',
    component: AdminHomeView,
    meta: { requiresAuth: true }
  },
  {
    path: '/home/exam-session-info',
    name: 'home-exam-session-info',
    component: AdminHomeView,
    meta: { requiresAuth: true }
  },
  {
    path: '/home/city-paper-manage',
    name: 'home-city-paper-manage',
    redirect: '/home/city-signup?adminTab=cityPaperManage',
    meta: { requiresAuth: true }
  },
  {
    path: '/home/question-manage',
    name: 'home-question-manage',
    redirect: '/home/city-signup?adminTab=questionManage',
    meta: { requiresAuth: true }
  },
  {
    path: '/home/ticket-login-page-manage',
    name: 'home-ticket-login-page-manage',
    redirect: '/home/city-signup?adminTab=ticketLoginPageManage',
    meta: { requiresAuth: true }
  },
  {
    path: '/event',
    name: 'event-public',
    component: EventPublicIntroView
  },
  {
    path: '/event/detail/:id',
    name: 'event-public-detail',
    component: EventDetailPublicView
  },
  {
    path: '/admin/home',
    name: 'admin-home',
    redirect: '/home/city-signup'
  },
  {
    path: '/admin/city-signup',
    name: 'admin-city-signup',
    redirect: '/admin/home'
  },
  {
    path: '/city-signup/:token',
    name: 'city-signup-open',
    component: CityExamSignupPublicView
  },
  {
    path: '/ticket-login/:token',
    name: 'ticket-login-open',
    component: TicketLoginPublicView
  },
  {
    path: '/automan-sso',
    name: 'automan-sso',
    component: AutomanSsoView
  },
  {
    path: '/teacher/home',
    name: 'teacher-home',
    redirect: '/teacher/questions',
    meta: { requiresAuth: true }
  },
  {
    path: '/student/home',
    name: 'student-home',
    component: StudentHomeView,
    meta: { requiresAuth: true }
  },
  {
    path: '/student/more-info',
    name: 'student-more-info',
    component: StudentMoreInfoView,
    meta: { requiresAuth: true }
  },
  {
    path: '/student/scratch-exam',
    name: 'student-scratch-exam',
    component: () => import('../views/StudentScratchExamView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/teacher/scratch-grade',
    name: 'teacher-scratch-grade',
    component: () => import('../views/StudentScratchExamView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/teacher/questions',
    name: 'teacher-questions',
    component: TeacherQuestionManageView,
    meta: { requiresAuth: true }
  },
  {
    path: '/teacher/papers',
    name: 'teacher-papers',
    component: TeacherPaperManageView,
    meta: { requiresAuth: true }
  },
  {
    path: '/teacher/grading',
    name: 'teacher-grading',
    component: TeacherGradingWorkspaceView,
    meta: { requiresAuth: true }
  },
  {
    path: '/teacher/proctor-wall',
    name: 'teacher-proctor-wall',
    component: TeacherProctorWallView,
    meta: { requiresAuth: true }
  },
  {
    path: '/teacher/proctor',
    name: 'teacher-proctor',
    component: TeacherProctorView,
    meta: { requiresAuth: true }
  },
  {
    path: '/teacher/exam-records',
    name: 'teacher-exam-records',
    component: TeacherExamRecordManageView,
    meta: { requiresAuth: true }
  },
  {
    path: '/teacher/students',
    name: 'teacher-students',
    component: TeacherStudentUserManageView,
    meta: { requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  /** Hash 模式 + BASE_URL：支持部署在 nginx 子路径（与 vue.config publicPath 一致） */
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const normalizeRole = (value) => String(value || '').trim().toLowerCase()
  const requiredRoleByPath = () => {
    if (to.path.startsWith('/teacher/')) return 'teacher'
    if (to.path.startsWith('/student/')) return 'student'
    if (to.path.startsWith('/home/') || to.path.startsWith('/admin/')) return 'admin'
    return ''
  }
  if (to.meta && to.meta.requiresAuth) {
    let user = null
    try {
      user = JSON.parse(localStorage.getItem('exam_user') || 'null')
    } catch (e) {
      localStorage.removeItem('exam_user')
      user = null
    }
    if (!user) {
      next({ path: '/' })
      return
    }
    const requiredRole = requiredRoleByPath()
    const ur = normalizeRole(user.role)
    if (requiredRole && ur !== requiredRole) {
      if (requiredRole === 'teacher' && ur === 'admin') {
        next()
        return
      }
      next({ path: '/' })
      return
    }
  }
  next()
})

export default router
